


  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4">
    <!-- Brand Logo -->
    <a href="index3.html" class="brand-link">
      <img src="assets/img/AdminLTELogo.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3"
        style="opacity: .8">
      <span class="brand-text font-weight-light">Prid Ecommerece</span>
    </a>

    <!-- Sidebar -->
    <app-admin-side-bar></app-admin-side-bar>
    <!-- /.sidebar -->
  </aside>

  <!-- Control Sidebar -->
  <aside class="control-sidebar control-sidebar-dark">
    <!-- Control sidebar content goes here -->
  </aside>
  <!-- /.control-sidebar -->

<!-- Navbar -->
<nav class="main-header navbar navbar-expand navbar-dark">
  <!-- Left navbar links -->
 
  <!-- Right navbar links -->
  <ul class="navbar-nav ml-auto">
    <li class="nav-item dropdown">
      <!-- <a><app-admin-test-mode></app-admin-test-mode> </a> -->
  </li>
  </ul>
</nav>
<!-- /.navbar -->

<div class="content-wrapper">

  <section class="content-header">
    <div class="container-fluid">
        <div class="row">
            <div class="col-5"></div>
            <div class="col-2">
              <div *ngIf="Loader == true">
                <app-loader style="text-align: center"></app-loader>
              </div>
            </div>
            <div class="col-5"></div>
          </div>
      <div class="row mb-2">
        <div class="col-sm-6">
          <h1>Payements</h1>
        </div>
        <div class="col-sm-6">
          <ol class="breadcrumb float-sm-right">
            <li class="breadcrumb-item"><a>Home</a></li>
            <li class="breadcrumb-item active">Payement Successful</li>
          </ol>
        </div>
      </div>
    </div><!-- /.container-fluid -->
  </section>

  <div class="container-fluid" style="padding: 15px;">

    <div class="row ">
      <section class="col-md-6">
        <h1>Payment Successful!</h1>
        <h1>Processing your payment details...</h1>        
      </section>
    </div>
  </div>


</div>

  <!-- Main Footer -->
  <footer class="main-footer">
    <strong>Copyright &copy; 2014-2021 <a href="https://adminlte.io">AdminLTE.io</a>.</strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <b>Version</b> 3.2.0
    </div>
  </footer>

